/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Typography,
  Form,
  Popover,
  Button,
  Progress,
  message,
} from "antd";
import LoginTemplate from "./LoginTemplate";
import axios from "axios";
import { authService, SITEKEY } from "../../../configs/constants";
import { useForm } from "react-hook-form";
import { InputField, InputPassword } from "../../atoms/FormElement";
// import { ReCaptcha, loadReCaptcha } from "react-recaptcha-v3";

const { Text } = Typography;

const ChangePassword = (props) => {
  const [loading, setLoading] = useState(false);
  // const [tokenCapcha, setReCapcha] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  

  const {
    control,
    handleSubmit,
    formState:{errors},
    watch,
    formState,
    getValues,
  } = useForm({ mode: "onChange" });
  const { isValid } = formState;
  let checkPassword = watch("password");
  // const refReCaptcha = useRef(null);

  // useEffect(() => {
  //   loadReCaptcha(SITEKEY);
  // }, []);

  const content = (
    <div>
      {/* <Progress
        percent={30}
        size="small"
        status="exception"
        showInfo={false}
        style={{ width: "230px" }}
      /> */}
      <ul className="ag-unordered-list">
        <li>One Upper Case letter</li>
        <li>One Lower Case letter</li>
        <li>One Number</li>
        <li>One Special Character</li>
      </ul>
    </div>
  );

  // useEffect(() => {
  //   loadReCaptcha(SITEKEY);
  // }, []);

  // const verifyCallback = (token) => {
  //   // console.log("recaptch", token);
  //   setReCapcha(token);
  // };

  const onFinish = async (values) => {
    setLoading(true);
    const { usercode, password } = values;
    const url = `${authService}/user/resetpassword`;
    const usr = location?.state.UserName;
    // console.log("usr", usr);

    const postJson = {
      email: usr?.toLowerCase(),
      password: password,
      usertype: "institutionalLandlord",
      otp: usercode,
      // recapcha: tokenCapcha,
    };

    // console.log("DTEA",usr);

    try {
      await axios.post(url, postJson);
      message.success("Password successfully updated");
      setTimeout(() => navigate("/login"), 3000);
    } catch (e) {
      // refReCaptcha.current.execute();
      setLoading(false);
      const { response } = e;
    // console.log("DTEA",response);

      message.error(response?.data?.error);
    }
  };

  return (
    <LoginTemplate load={loading}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Text className="ag-primary RegularFont">Change Password</Text>
        </Col>
        <Col span={24}>
          <Form name="normal_login" onFinish={handleSubmit(onFinish)} >
            <InputField
              isRequired={true}
              fieldname="usercode"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Enter code",
                size: "large",
                type: "number",
              }}
              rules={{
                required: "Please input your Code!",
              }}
              validate={errors.usercode && "error"}
              validMessage={errors.usercode && errors.usercode.message}
            />
            <Popover
              placement="rightTop"
              title="Password must contain: 8 characters"
              content={content}
              trigger="click"
              visible={errors.password ? true : false}
            >
              <InputPassword
                isRequired={true}
                fieldname="password"
                control={control}
                initValue=""
                iProps={{ placeholder: "Password", size: "large" }}
                rules={{
                  pattern: {
                    value: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^!-_&*+=]).*$/,
                    // message: "Passwords must contain at least 8 characters, 1 capital letter, 1 number and a special character",
                  },
                  required: "Please enter password",
                }}
                validate={errors.password && "error"}
                validMessage={errors.password && errors.password.message}
              />
            </Popover>
            <InputPassword
              isRequired={true}
              fieldname="confirm"
              control={control}
              initValue=""
              iProps={{ placeholder: "Re-enter new password", size: "large" }}
              rules={{
                required: "Please confirm your password!",
                validate: (value) =>
                  value === checkPassword || "The passwords do not match",
              }}
              validate={errors.confirm && "error"}
              validMessage={errors.confirm && errors.confirm.message}
            />
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
                disabled={!isValid}
              >
                Change Password
              </Button>
            </Form.Item>
            {/* <ReCaptcha
              ref={refReCaptcha}
              action="main"
              sitekey={SITEKEY}
              verifyCallback={verifyCallback}
            /> */}
          </Form>
        </Col>
      </Row>
    </LoginTemplate>
  );
};

export default ChangePassword;
